import ProductsMain from "../components/products/ProductsMain"

function Products() {
  return (
    <ProductsMain />
  )
}

export default Products